import { makeStyles, Theme } from '@material-ui/core/styles';

const useStylesPaper = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    defaultPaper: {
        padding: '15px',
        minHeight: '20px'
    },
    configurationPaper: {
        marginBottom: theme.spacing(3),
        height: '74vh',
        maxHeight: '74vh',
    }
}));

export default useStylesPaper;
